// components/Blog/Sidebar/BlogSidebar.jsx
import { Link, useSearchParams } from "react-router-dom";

function stripTags(s = "") {
  return String(s).replace(/<[^>]*>/g, "").trim();
}

export default function BlogSidebar({
  cats = [],
  onPickCategory,
  recent = [],
  tags = [],
  activeCategoryId, // valinnainen: ulkoa annettava aktiivinen kategoria
}) {
  // Jos activeCategoryId ei tule propseista, luetaan se URL:sta
  const [params] = useSearchParams();
  const urlCat = params.get("category") || "";
  const currentCat = String(
    activeCategoryId != null ? activeCategoryId : urlCat
  );

  return (
    <aside className="sticky top-24 space-y-6">
      {/* Kategoriat */}
      <section className="rounded-2xl p-5 bg-white/70 dark:bg-zinc-900/60 ring-1 ring-white/10">
        <h3 className="text-lg font-semibold mb-3 dark:text-white text-black/80">
          Kategoriat
        </h3>
        <div className="flex flex-wrap gap-2">
          {cats.map((c) => {
            const id = String(c.id);
            const active = id === currentCat && currentCat !== "";
            return (
              <button
                key={id}
                type="button"
                onClick={() => onPickCategory(id)}
                aria-pressed={active}
                className={[
                  "px-3 py-1.5 rounded-full text-sm transition",
                  active
                    ? "bg-electric text-black font-semibold ring-2 ring-electric/60"
                    : "bg-pink dark:bg-zinc-800 text-white/80 dark:text-white/80 hover:brightness-110",
                ].join(" ")}
              >
                {c.name}
              </button>
            );
          })}
        </div>
      </section>

      {/* Tuoreimmat */}
      {!!recent.length && (
        <section className="rounded-2xl p-5 bg-white/70 dark:bg-zinc-900/60 ring-1 ring-white/10">
          <h3 className="text-lg font-semibold mb-3 dark:text-white text-black/80">
            Tuoreimmat
          </h3>
          <ul className="space-y-2">
            {recent.map((p) => (
              <li key={p.id}>
                <Link
                  to={`/blogi/${p.slug}`}
                  className="text-black/80 dark:text-white/80 hover:underline"
                  aria-current={undefined}
                  title={stripTags(p.title?.rendered || "")}
                >
                  {stripTags(p.title?.rendered || "")}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}

      {/* Tunnisteet (valinnainen) */}
      {!!tags.length && (
        <section className="rounded-2xl p-5 bg-white/70 dark:bg-zinc-900/60 ring-1 ring-white/10">
          <h3 className="text-lg font-semibold mb-3 dark:text-white text-black/80">
            Tunnisteet
          </h3>
          <div className="flex flex-wrap gap-2">
            {tags.slice(0, 20).map((t) => (
              <Link
                key={t.id}
                to={`/blogi?search=${encodeURIComponent(t.name)}`}
                className="px-2 py-1 rounded bg-zinc-100 dark:bg-zinc-800 text-xs dark:text-white/80"
              >
                #{t.name}
              </Link>
            ))}
          </div>
        </section>
      )}

      {/* RSS + share */}
      <section className="rounded-2xl p-5 bg-white/70 dark:bg-zinc-900/60 ring-1 ring-white/10">
        <a
          href="/feed/"
          type="application/rss+xml"
          className="text-sm dark:text-white/80 text-black/80 hover:underline"
        >
          RSS-syöte
        </a>
      </section>
    </aside>
  );
}
